export default "__VITE_ASSET__b9d0c5d7__"